import type {
  Catalog,
  EntitlementSnapshot,
  Subscription,
} from '../../api/billing.service';
import { route, type HandlerEntry } from '../handler-registry';

const PERIOD_DAYS = 30;
const DEMO_PLAN_CODE = 'pro';
const DEMO_ERROR = {
  status: 400,
  message: 'Plățile nu sunt disponibile în modul demo.',
};

function periodEnd(): string {
  return new Date(Date.now() + PERIOD_DAYS * 86_400_000).toISOString();
}

const DEMO_CATALOG: Catalog = {
  appCode: 'sportdesk',
  plans: [
    {
      planCode: 'free',
      name: 'Free',
      description: 'Pentru cluburi mici care încep.',
      features: [
        'Până la 10 sportivi',
        'Până la 2 antrenori',
        '20 sesiuni / lună',
      ],
      prices: [
        {
          priceId: 'demo-free-monthly',
          amount: 0,
          currency: 'RON',
          billingPeriod: 'Monthly',
          trialDays: 0,
        },
      ],
    },
    {
      planCode: 'pro',
      name: 'Pro',
      description: 'Tot ce ai nevoie ca să-ți crești clubul.',
      features: [
        'Sportivi nelimitați',
        'Antrenori nelimitați',
        'Sesiuni nelimitate / lună',
        'Pagină publică pentru club',
      ],
      prices: [
        {
          priceId: 'demo-pro-monthly',
          amount: 99,
          currency: 'RON',
          billingPeriod: 'Monthly',
          trialDays: 14,
        },
        {
          priceId: 'demo-pro-annual',
          amount: 990,
          currency: 'RON',
          billingPeriod: 'Annual',
          trialDays: 14,
        },
      ],
    },
    {
      planCode: 'premium',
      name: 'Premium',
      description: 'Pentru cluburi mari, cu suport prioritar.',
      features: [
        'Tot din Pro',
        'Suport prioritar',
        'Onboarding dedicat',
      ],
      prices: [
        {
          priceId: 'demo-premium-monthly',
          amount: 199,
          currency: 'RON',
          billingPeriod: 'Monthly',
          trialDays: 0,
        },
        {
          priceId: 'demo-premium-annual',
          amount: 1990,
          currency: 'RON',
          billingPeriod: 'Annual',
          trialDays: 0,
        },
      ],
    },
  ],
};

export const billingHandlers: readonly HandlerEntry[] = [
  route(
    'GET',
    /^\/api\/tenants\/([^/]+)\/billing\/subscription$/,
    (_ctx, data): Subscription => ({
      tenantId: data.tenant.tenantId,
      provisioned: true,
      planCode: DEMO_PLAN_CODE,
      currentPeriodEnd: periodEnd(),
      accessEnabled: true,
    }),
  ),
  route(
    'GET',
    /^\/api\/tenants\/([^/]+)\/billing\/entitlements$/,
    (): EntitlementSnapshot => ({
      planCode: DEMO_PLAN_CODE,
      currentPeriodEnd: periodEnd(),
      accessEnabled: true,
      publicPageEnabled: true,
      athletesMax: 0,
      coachesMax: 0,
      sessionsMonthlyLimit: 0,
      schedulesMax: 0,
      athletesOveragePrice: 0,
    }),
  ),
  route(
    'GET',
    /^\/api\/tenants\/([^/]+)\/billing\/catalog$/,
    (): Catalog => DEMO_CATALOG,
  ),
  route(
    'POST',
    /^\/api\/tenants\/([^/]+)\/billing\/orders$/,
    () => ({ error: DEMO_ERROR }),
  ),
  route(
    'POST',
    /^\/api\/tenants\/([^/]+)\/billing\/orders\/([^/]+)\/checkout$/,
    () => ({ error: DEMO_ERROR }),
  ),
  route(
    'POST',
    /^\/api\/tenants\/([^/]+)\/billing\/subscription\/cancel$/,
    () => ({ error: DEMO_ERROR }),
  ),
  route(
    'POST',
    /^\/api\/tenants\/([^/]+)\/billing\/refresh$/,
    () => ({ error: DEMO_ERROR }),
  ),
];
